<template>
  <div class="input-group">
    <input
      v-if="showInput"
      :value="value"
      type="text"
      class="form-control"
      :class="inputSize"
      v-bind="$attrs"
      @input="$emit('input', $event.target.value)"
    >
    <div class="input-group-append">
      <uploader-wrapper :token-url="tokenUrl" @update:imagePath="$emit('input', $event)">
        <button class="btn btn-outline-secondary" :class="buttonSize" type="button">
          Upload
        </button>
      </uploader-wrapper>
    </div>
  </div>
</template>

<script>
  import UploaderWrapper from "@/FormWidgets/UploaderWrapper/UploaderWrapper.vue";

  export default {
    name: "UrlInputWithUpload",
    components: {UploaderWrapper},
    /** The URL to upload to */
    // todo: should the inject happen in UploaderWrapper, and the inbox be refactored to match?
    inject: ['uploadTokenUrl'],
    inheritAttrs: false,
    props: {
      /** The URL of the image, to put in the <input> */
      value: {
        type: String,
        default: ""
      },
      /** Whether to show the <input> */
      // todo: Would it be more elegant to use UploaderWrapper alone when false instead? Would require duplicating button code
      showInput: {
        type: Boolean,
        default: true
      },
      /** Size of the input and button. Options are "sm", "md" and "lg" */
      size: {
        type: String,
        default: "md",
      }
    },
    data() {
      return {
        // todo: remove dollar sign version
        tokenUrl: this.uploadTokenUrl || this.$uploadTokenUrl || '/uploadToken?container=public-images'
      }
    },
    computed: {
      inputSize() {
        return `form-control-${this.size}`;
      },
      buttonSize() {
        return `btn-${this.size}`;
      }
    }
  }
</script>

<style scoped>
div {
  /** todo: properly scope event-logic.scss and remove */
  margin-top: 0 !important;
}

</style>